import Divider from '@components/Divider';
import { OptionGroup } from '@models/item';
import { Fragment } from 'react';

import useIconOptionGroups from './hooks/useIconOptionGroups';
import IconOption from './IconOption';
import TextOption from '../../../_shared/components/TextOption';

interface Props {
    optionGroups: OptionGroup[];
    itemId: string;
}

function DefaultOptions({ optionGroups, itemId }:Props) {
    const { iconOptionGroups, textOptionGroups } = useIconOptionGroups(optionGroups);
    if (optionGroups.length === 0) {
        return null;
    }
    return (
        <Fragment>
            {iconOptionGroups.map((optionGroup) => (
                <IconOption optionGroup={optionGroup}
                    itemId={itemId}
                    key={optionGroup.optionGroupId} />
            ))}
            {textOptionGroups.map((optionGroup) => (
                <TextOption optionGroup={optionGroup}
                    itemId={itemId}
                    key={optionGroup.optionGroupId} />
            ))}
        </Fragment>
    );
}

export default DefaultOptions;
